export const ERROR_CODE = 0

export const BASEURL = 'https://www.hzflkj.cn/'

export const COLOR = '#38A28A'


// WEBPACK FOOTER //
// ./src/utils/common/config.js